import type { MobiusSubscriptionStatus, MobiusTenant } from "@/types";

// Keycloak splits tenant info across several flat claim arrays to stay under its 255-char group-attribute limit.
// Each entry (other than tenant_id) is prefixed with "{tenant_id}," so values can be matched back to their tenant.
export function mapTokenToTenants(claims: Record<string, unknown> | undefined): MobiusTenant[] {
  const tenantIds = claims?.tenant_id as string[] | undefined;
  if (!tenantIds?.length) return [];

  const names = indexByTenantId(claims?.tenant_name);
  const versionTags = indexByTenantId(claims?.version_tag);
  const planIds = indexByTenantId(claims?.subscription_plan_id);
  const statuses = indexByTenantId(claims?.subscription_status);
  const isActives = indexByTenantId(claims?.subscription_is_active);

  return tenantIds.map((idStr) => ({
    id: Number(idStr),
    name: names.get(idStr) ?? "",
    version_tag: versionTags.get(idStr) ?? "",
    subscription: {
      plan_id: planIds.get(idStr) ?? "",
      status: statuses.get(idStr) as MobiusSubscriptionStatus | undefined,
      is_active: isActives.get(idStr) === "True"
    }
  }));
}

function indexByTenantId(claim: unknown): Map<string, string> {
  const map = new Map<string, string>();
  if (!Array.isArray(claim)) return map;
  for (const entry of claim as string[]) {
    const commaIdx = entry.indexOf(",");
    if (commaIdx === -1) continue;
    map.set(entry.slice(0, commaIdx), entry.slice(commaIdx + 1));
  }
  return map;
}
